/**
 * One round half rendered as a fixed-height column: its `N` boxes each take an equal `trackH / N`
 * slot (box centred), so sibling boxes line up with the elbow connectors on either side.
 */

import React, { useMemo } from 'react'
import { View } from 'react-native'
import type { BracketRound } from '../../../src/knockout/types/knockoutBracket.types'
import { slotStyle, trackStyle } from '../../../src/knockout/helpers/bracketGeometry.helper'
import { KnockoutMatchBox } from './KnockoutMatchBox'
import { getBracketRoundColumnStyles } from './BracketRoundColumn.styles'

interface BracketRoundColumnProps {
  round: BracketRound
  trackH: number
}

export const BracketRoundColumn: React.FC<BracketRoundColumnProps> = ({ round, trackH }) => {
  const styles = useMemo(() => getBracketRoundColumnStyles(), [])
  const count = round.matches.length

  return (
    <View style={[styles.column, trackStyle(trackH)]}>
      {round.matches.map((m) => (
        <View key={m.id} style={[styles.slot, slotStyle(trackH, count)]}>
          <KnockoutMatchBox match={m} />
        </View>
      ))}
    </View>
  )
}
